import React from 'react';
import PropTypes from 'prop-types';
import {ContentItems} from './ContentItems';
import {ContentFooter} from './ContentFooter';
import './style.scss';

export class NotebookContent extends React.Component {

  constructor(props) {
    super(props);
    this.notebookContentBody = React.createRef();
  }

  componentDidUpdate(prevProps){
    if(prevProps.title !== this.props.title){
      this.notebookContentBody.current.scrollTop = 0;
    }
  }

  render() {
    return (
      <div className='notebook-content' ref={this.notebookContentBody}>
        <div className='notebook-content__body'>
          <div className='title'>
            <h2>{this.props.title}</h2>
          </div>
          <ContentItems />
        </div>
        <ContentFooter />
      </div>
    );
  }
}
NotebookContent.propTypes = {
  title: PropTypes.string,
};
